import { delayedFunction } from 'utils/functional/function/delayedFunction';
import {
  RunAsyncUntilCompleteResult,
  runAsyncUntilComplete,
} from 'utils/functional/function/runAsyncUntilComplete';
import { runAsyncWithErrorMessage } from 'utils/functional/function/runAsyncWithErrorMessage';
import { getJson } from 'utils/http';

import { BackgroundTask } from './asyncBackendTaskTypes';

type WaitTaskCompletedOptions<TResult, TStep extends string> = {
  onTick?: (task: BackgroundTask<TResult, TStep>) => void;
};

export function waitTaskCompleted<TResult, TStep extends string = ''>(
  backgroundTask: BackgroundTask<TResult, TStep>,
  options: WaitTaskCompletedOptions<TResult, TStep> = {}
): Promise<TResult> {
  const fetchTask = () =>
    runAsyncWithErrorMessage(
      () =>
        getJson<{ task: BackgroundTask<TResult, TStep> }>(backgroundTask.url),
      'Request failed'
    );

  return runAsyncUntilComplete(
    delayedFunction<RunAsyncUntilCompleteResult<TResult>>({
      fn: async () => {
        const { task } = await fetchTask();
        options.onTick?.(task);

        if (task.status === 'COMPLETED') {
          return { type: 'completed', data: task.result };
        }

        return { type: 'not-completed' };
      },
      delayMs: 500,
    })
  );
}
